import { For } from 'solid-js'

type ChartValueAxisProps = {
   ticks: number[]
   toY: (value: number) => number
   formatValue: (value: number) => string
   left: number
   right: number
}

/**
 * Renders a chart's horizontal dotted grid with a formatted label per tick.
 *
 * @param props - Tick values, the y mapper, formatter, and horizontal extent.
 * @returns The axis elements.
 */
const ChartValueAxis = (props: ChartValueAxisProps) => (
   <For each={props.ticks}>
      {tick => (
         <g>
            <line
               x1={props.left}
               x2={props.right}
               y1={props.toY(tick)}
               y2={props.toY(tick)}
               stroke="var(--chart-grid, rgba(148, 163, 184, 0.2))"
               stroke-dasharray="2 5"
            />
            <text
               x={props.left - 8}
               y={props.toY(tick)}
               text-anchor="end"
               dominant-baseline="middle"
               font-size="12"
               fill="currentColor"
            >
               {props.formatValue(tick)}
            </text>
         </g>
      )}
   </For>
)

export default ChartValueAxis
